// extracted by mini-css-extract-plugin
module.exports = {"counter":"ade49","light":"_18e72","dark":"d7876","accent":"_24f9c"};